import {ColDef, ValueFormatterParams} from 'ag-grid-community';
import {formatThousands} from '../../../../shared-utilities/utils-old/formatting';

const formatDebtorBalanceValue = (params: ValueFormatterParams): string => {
  const value = Number(params.value);
  if (!Number.isFinite(value)) {
    return '—';
  }
  return `R ${formatThousands(value, 2)}`;
};
const ACCOUNT_COL_BASE: ColDef = {
  field: 'debtorId',
  headerName: 'Account',
  hide: false,
  pinned: 'left',
  resizable: true,
  lockPinned: true,
  lockPosition: true,
  type: ['alignRight'],
  editable: false,
  width: 200,
  cellEditor: false,
  suppressHeaderMenuButton: true,
};

const NAME_COL_BASE: ColDef = {
  field: 'name',
  headerName: 'Name',
  hide: false,
  lockPinned: true,
  resizable: true,
  editable: false,
  cellEditor: false,
  suppressHeaderMenuButton: true,
};

/**
 * Debtor grid columns for mobile — account, name, and contact details.
 */
export const SHARED_DEBTOR_SEARCH_MOBILE_COL_DEFS: ColDef[] = [
  {...ACCOUNT_COL_BASE},
  {...NAME_COL_BASE},
  {
    field: 'contact',
    headerName: 'Contact',
    hide: false,
    lockPinned: true,
    resizable: true,
    editable: false,
    cellEditor: false,
    suppressHeaderMenuButton: true,
  },
  {
    field: 'telephone1',
    headerName: 'Contact No.',
    hide: false,
    lockPinned: true,
    resizable: true,
    editable: false,
    cellEditor: false,
    suppressHeaderMenuButton: true,
  },
];
/**
 * Debtor grid columns for desktop — includes contact details.
 */
export const SHARED_DEBTOR_SEARCH_DESKTOP_COL_DEFS: ColDef[] = [
  {...ACCOUNT_COL_BASE},
  {...NAME_COL_BASE},
  {
    field: 'contact',
    headerName: 'Contact',
    hide: false,
    lockPinned: true,
    resizable: true,
    editable: false,
    cellEditor: false,
    suppressHeaderMenuButton: true,
  },
  {
    field: 'telephone1',
    headerName: 'Contact No.',
    hide: false,
    lockPinned: true,
    resizable: true,
    editable: false,
    cellEditor: false,
    suppressHeaderMenuButton: true,
  },
  {
    field: 'total',
    headerName: 'Balance',
    hide: false,
    lockPinned: true,
    resizable: true,
    editable: false,
    type: ['alignRight'],
    valueFormatter: formatDebtorBalanceValue,
    cellEditor: false,
    suppressHeaderMenuButton: true,
  },
  {
    field: 'email',
    headerName: 'Email',
    hide: false,
    lockPinned: true,
    resizable: true,
    editable: false,
    cellEditor: false,
    suppressHeaderMenuButton: true,
  },
];
